export default class Standings {
  rank: number;
  leagueId: number;
  leagueName: string;
  raceId: number;
  userId: number;
  teamId: number;
  teamName: string;
  racePoints: number;
  tieBreakerGap: number;
  bonusPoints: number;
  finishFirstPoints: number;
  finishSecondPoints: number;
  finishThirdPoints: number;
  totalPoints: number;
  lapsCompleted: number;
  totalLaps: number;
  isUser: number;
  isPrivate: number;
  brandId: number;
  isOfficial: number;
  raceName: number;
  raceStatus: number;
  raceLogoUrl: number;
  isAdmin: number;
  constructor(starter: any = {}) {
    this.rank = starter.rank || 0;
    this.leagueId = starter.leagueId || 0;
    this.leagueName = starter.leagueName || null;
    this.raceId = starter.raceId || 0;
    this.userId = starter.userId || null;
    this.teamId = starter.teamId || 0;
    this.teamName = starter.teamName || null;
    this.racePoints = starter.racePoints || 0;
    this.tieBreakerGap = starter.tieBreakerGap || 0;
    this.bonusPoints = starter.bonusPoints || 0;
    this.finishFirstPoints = starter.finishFirstPoints || 0;
    this.finishSecondPoints = starter.finishSecondPoints || 0;
    this.finishThirdPoints = starter.finishThirdPoints || 0;
    this.totalPoints = starter.totalPoints || 0;
    this.lapsCompleted = starter.lapsCompleted || 0;
    this.totalLaps = starter.totalLaps || 0;
    this.isUser = starter.isUser || false;
    this.isPrivate = starter.isPrivate || false;
    this.brandId = starter.brandId || 0;
    this.isOfficial = starter.isOfficial || false;
    this.raceName = starter.raceName || null;
    this.raceStatus = starter.raceStatus || null;
    this.raceLogoUrl = starter.raceLogoUrl || null;
    this.isAdmin = starter.isAdmin || true;
  }
}
